module.exports = "<div>\r\n    <ng-template appInsertion></ng-template>\r\n</div>\r\n<div class=\"overlay\" (click)=\"onClickOverlay()\"></div>"